/// <reference path="../../Common/Base/SiteEntityDialog.ts" />

namespace Matrix.Data {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.responsive()
    @Serenity.Decorators.panel()
    export class PartyRelationshipDialog extends SiteEntityDialog<PartyRelationshipRow, any> {
        protected getFormKey() { return PartyRelationshipForm.formKey; }
        protected getIdProperty() { return PartyRelationshipRow.idProperty; }
        protected getLocalTextPrefix() { return PartyRelationshipRow.localTextPrefix; }
        protected getService() { return PartyRelationshipService.baseUrl; }

        protected form = new PartyRelationshipForm(this.idPrefix);
    }
}